import { Subscription, Subject } from 'rxjs';
import { AbstractCustomControl, MakeProvider } from "../abstract-custom-control";
import { ChangeDetectorRef, Input, ViewChild, ElementRef, Component, ChangeDetectionStrategy, Output, EventEmitter, HostListener } from "@angular/core";
import { QueryParameter } from "../../base-models/query-parameter";
import { BaseEntity } from "../../base-models/base-entity";
import { ModelData } from "../../base-models/model-data";
import { ModelDataService } from "../../base-services/model-data.service";
import { BaseDataService } from "../../base-services/base-data.service";
import { CollectionService } from '../../base-services/collection.service';
import { DropDownControlButtonsComponent } from '../dropdown/dropdown-buttons/drop-down-control-buttons.component';
import { debounceTime } from 'rxjs/operators';
import { DefaultTableComponent } from '../default-table/default-table.component';
import { List } from 'immutable';
import random from '@angular-devkit/schematics/src/rules/random';

@Component({
    selector: 'yt-autocomplete',
    templateUrl: './autocomplete.component.html',
    providers: [
        MakeProvider(AutocompleteComponent)
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class AutocompleteComponent<T extends BaseEntity> extends AbstractCustomControl<any>{
    constructor(protected changeDetectorRef: ChangeDetectorRef,
                protected modelDataService: ModelDataService,
                protected baseDataService: BaseDataService,
                protected collectionService: CollectionService){
        super(changeDetectorRef);
        this.onChangeSubject
                    .pipe(
                        debounceTime(500))
                            .subscribe(val => {
                                this.loadItems(val);
                        })
    }

    Items: List<T>;
    _modelData: ModelData;
    itemsLoading: boolean = false;
    private _itemsSubscription: Subscription;
    tableConfig: any = {};
    showPicklist: boolean = false;
    displayValue: string;

    private onChangeSubject = new Subject<string>();
    //private itemsLoadedSubject = new Subject<number>();
    //itemsLoadedObservable = this.itemsLoadedSubject.asObservable();
    loading: boolean = false;
    autocompleteName: number = parseInt((Math.random() * 1000).toString(), 10);

    @HostListener('document:click', ['$event'])
    onClick(event){
        let selector: string = 'div[name="autocomplete' + this.autocompleteName + '"]';
        if(event.target.closest(selector) == null){
            this.showPicklist = false;
        }
    }

    @Input() ModelName: string;
    @Input() GetName: string;
    @Input() GetParameters: QueryParameter[];
    @Input() ModelProperty: string;
    @Input() OrderBy: string;
    @Input() AllowAddNew: boolean;
    @Input() set Source(value: T[]){
        this.Items = List(value);
    }
    @Input() TabStopOnButtons: boolean = true;
    @Input() ShowHeader: boolean = false;


    @Output() OnItemSelected: EventEmitter<T> = new EventEmitter();

    @ViewChild('input', { static: true }) inputControl: ElementRef;
    @ViewChild('dropDownControlButtons', { static: false }) dropDownControlButtons: DropDownControlButtonsComponent;
    @ViewChild('defaultTable', { static: true }) defaultTable: DefaultTableComponent;

    ngOnInit(){
        this._modelData = this.modelDataService.GetModelDataByPath(this.ModelName);
        this.tableConfig = {
            EditIcon: {
                Visible: false
            },
            DeleteIcon: {
                Visible: false
            },
            DefaultSortKey: this.OrderBy,
            DefaultSortReverse: false,
            ShowIndex: false,
            ShowDefaultListButtons: false,
            Height: '294px',
            ShowCheckBoxes: false,
            PrintIcon: {
                Visible: false
            },
            ShowSearch: false,
            ShowHeader: this.ShowHeader,
            ShowFooter: false
        }
    }

    setDisabledState(isDisabled: boolean){
        this.inputControl.nativeElement.disabled = isDisabled;
        // this.dropDownControlButtons.isDisabled = isDisabled;
    }

    focus(){
        super.focus();
        let __this = this;
        setTimeout(function(){
            __this.inputControl.nativeElement.focus();
        }, 100);
    }

    onInput(value: string){
        this.onChangeSubject.next(value);
        this.loading = true;
        this.changeDetectorRef.markForCheck();
    }

    private loadItems(value: string, showPicklist: boolean = true){
        if(value && value.length > 1){
            this._modelData = this.modelDataService.GetModelDataByPath(this.ModelName);
            if(this.ModelName && this.GetName){
                this.itemsLoading = true;
                let queryParameter: QueryParameter = new QueryParameter();
                let queryParameters: QueryParameter[] = [];
                queryParameter.Name = this.ModelProperty;
                queryParameter.Value = value;
                queryParameters.push(queryParameter);
                this.loading = true;
                this.changeDetectorRef.markForCheck();
                this._itemsSubscription = this.baseDataService.Get(this.ModelName, this.GetName, queryParameters, this._modelData.MainList.ShortModelClass)
                    .subscribe((data: T[]) => {
                        //this.showPicklist = true;
                        this.showPicklist = showPicklist;
                        this.Items = this.collectionService.SortItems(List(data), this.OrderBy, false);
                        this.itemsLoading = false;
                        //this.itemsLoadedSubject.next();
                        this.loading = false;
                        this.changeDetectorRef.markForCheck();
                    })
            }
        }
        else {
            this.Items = null;
            this.loading = false;
            this.changeDetectorRef.markForCheck();
        }
    }

    SelectItem(item: T){
        this.showPicklist = false;
        this.displayValue = item[this.ModelProperty];
        this.value = item.ID;
        this.OnItemSelected.emit(item);
    }

    Clear(){
        this._value = null;
        this.displayValue = null;
    }

    Add(){
    }

    togglePicklist(){
        this.showPicklist = !this.showPicklist;
    }

    onKeypress(event){
        //console.log(event, event.keyCode, event.keyIdentifier);
        this.defaultTable.KeyCode = event.keyCode;
        if((event.keyCode == 27 || event.keyCode == 9) && this.showPicklist){
            this.showPicklist = false;
        }
        else if(event.keyCode == 27){
            this.Clear()
        }
        if(event.keyCode == 13)
            event.preventDefault();
        event.stopPropagation();
    }

    writeValue(value){
        super.writeValue(value);

        this.getDisplayValue(value);
    }

    getDisplayValue(ID: number){
        if(ID == null){
            this.displayValue = '';
            this.changeDetectorRef.markForCheck();
            return;
        }

        this.baseDataService.GetByID(this.ModelName, ID, this._modelData.MainList.ShortModelClass)
            .subscribe((item: T) => {
                this.displayValue = item[this.ModelProperty];
                this.changeDetectorRef.markForCheck();
                this.loadItems(item[this.ModelProperty], false);
                this.OnItemSelected.emit(item);
            })
    }
}